import React from 'react';
import { ImageIcon, TargetIcon, PrinterIcon, FolderOpenIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: ImageIcon,
  color: 'text-teal-700'
}, {
  Icon: TargetIcon,
  color: 'text-amber-600'
}, {
  Icon: PrinterIcon,
  color: 'text-blue-950'
}, {
  Icon: FolderOpenIcon,
  color: 'text-green-600'
}];
export function BenefitsGrid() {
  return <section className="bg-slate-100 px-4 py-6 text-center md:px-12 md:py-8" data-id="element-10" data-mp="jp23uzjr043s">
      <h2 className="mx-auto max-w-[620px] text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-blue-950 md:text-[26px]" data-id="element-11" data-mp="extuu4mbykr5">
        This isn't another pediatric OT book filled with basic theory.
      </h2>
      <p className="mx-auto mt-1.5 max-w-[620px] text-[13px] font-bold uppercase leading-tight text-teal-700 md:text-[16px]" data-id="element-12" data-mp="505vt2hoyr36">
        It's an organized collection of practical professional resources.
      </p>
      <div className="mt-3 grid gap-2 text-left sm:grid-cols-2" data-id="element-13" data-mp="3s43r4a7yftxq">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i % icons.length];
        const isLastOdd = i === benefits.length - 1 && benefits.length % 2 === 1;
        return <article key={b.title} className={`flex gap-2.5 rounded-md border border-slate-200 bg-white p-3 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-14" data-mp="1wt9wmd4jkv6y" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-15" data-mp="21q06ujto0wkg" />
              <div data-id="element-16" data-mp="2uh0ct0bk4aer">
                <h3 className="text-[14px] font-bold leading-tight text-blue-950 md:text-[15px]" data-id="element-17" data-mp="2uhjv4i54d0tb">{b.title}</h3>
                <p className="mt-1 text-[13px] leading-[1.4] text-slate-600 md:text-[14px]" data-id="element-18" data-mp="2gg7hwehcfdb4">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
      <p className="mt-3.5 text-[13px] font-extrabold uppercase leading-tight text-amber-700 md:text-[15px]" data-id="element-19" data-mp="152c1z3im70iu">
        One system. Six professional skill areas. Five FREE bonuses.
      </p>
    </section>;
}